var $1f86ba72a65a99a5$exports = {};
$1f86ba72a65a99a5$exports = {
    "info": `Informa\u{21B}ii`,
    "negative": `Eroare`,
    "notice": `Avertisment`,
    "positive": `Succes`
};


export {$1f86ba72a65a99a5$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
